<div class="modal-container animate__animated " [class]="!isClosingModal ? 'animate__fadeIn' : 'animate__fadeOut'">

    <div class="modal animate__animated " [class]="!isClosingModal ? 'animate__fadeInDown' : 'animate__fadeOutUp'">

        <div class="flex justify-end">
            <button type="button" (click)="onResultEvent('Close')">
                <i class="fa-solid fa-xmark text-gray-400 text-2xl"></i>
            </button>
        </div>

        <div class="flex flex-col justify-center items-center break-words text-center">

            <div *ngIf="modalType === 'Confirmation'" class="flex items-center justify-center rounded-full bg-amber-600 h-12 w-12">
                <i class="fa-solid fa-triangle-exclamation text-white text-2xl"></i>
            </div>

            <div *ngIf="modalType === 'Info'" class="flex items-center justify-center rounded-full bg-sky-500 h-12 w-12">
                <i class="fa-solid fa-info text-white text-2xl"></i>
            </div>

            <h3 class="text-xl font-semibold my-4 w-full">
                {{ title }}
            </h3>
            <p class="text-gray-600 text-center w-full">
                {{ message }}
            </p>
            <p class="text-gray-400 my-4 text-center w-full" *ngIf="subMessage">
                {{ subMessage }}
            </p>
            <div class="flex items-center justify-center" *ngIf="linkText">
                <button class="text-blue-400 text-center text-md mt-6 cursor-pointer" (click)="onResultEvent('Link')">
                    {{ linkText }}
                </button>
            </div>
            <div class="flex items-center justify-center mt-6 gap-x-5 w-full" *ngIf="modalType === 'Confirmation'">
                <button class="button" (click)="onResultEvent('Cancel')">
                    No, cancelar
                </button>
                <button class="button red" (click)="onResultEvent('Confirm')">
                    Si, eliminar
                    <i class="fa-solid fa-trash-can icon"></i>
                </button>
            </div>
            <div class="flex items-center justify-center mt-6 gap-x-5 w-full" *ngIf="modalType === 'Info'">
                <button class="button green" (click)="onResultEvent('Accept')">
                    Aceptar
                </button>
            </div>
        </div>

    </div>

</div>